import { SELECIONAR_CIDADE } from '../types';

export default function selecionarCidade (data) {
  return {
    type: SELECIONAR_CIDADE,
    payload: data
  }
}
